export default __webpack_public_path__ + "static/media/wallet-icon.c12d1e6f.svg";